//   public async getApiKey() {
//     this.dialog = true;
//     if (this.getNewKey || app.$data.userInfo.wordpressApiKey === null) {
//       this.getNewKey = false;
//       this.hasKey = true;
//       this.requestKey = false;
//       await WordpressController.getApiKey(
//         app.$data.accessToken,
//         app.$data.refreshToken
//       ).then((response) => {
//         if (response.status === AuthResponseStatus.SUCCESS) {
//           this.setTokens(response);
//           app.$data.userInfo.wordpressApiKey = response.bearerKey;
//         } else {
//           this.dialog = false;
//         }
//         this.setSnackbar(response);
//       });
//     }
//   }
//
//   public getExpWordpressToken(): string {
//     if (app.$data.userInfo.wordpressApiKey !== null) {
//       return new Date(
//         this.parseToken(app.$data.userInfo.wordpressApiKey.split(' ')[1]).exp * 1000
//       ).toISOString();
//     }
//     return '';
//   }
// }
import { useRouter } from 'vue-router';
import { useUserStore } from '@/plugins/stores';
import NavigationHelper from '@/util/NavigationHelper';
import { Forms } from '@/enums/Forms';
import Service from '@/models/Service';
import { useI18n } from 'vue-i18n';
import PolteqButton from '@/components/PolteqButton/PolteqButton.vue';
import PageHelper from '@/util/PageHelper';

export default {
  name: 'IDOverview',
  components: { PolteqButton },
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const i18n = useI18n();
    const hasWordpressAccess = (services: Service[]) =>
      Boolean(services.find((service) => service.name.toLowerCase() === 'wordpress'));
    return {
      Forms,
      NavigationHelper,
      userStore,
      router,
      i18n,
      hasWordpressAccess,
      dialog: false,
      getNewKey: false,
      requestKey: false
    };
  },
  methods: {
    getExpWordpressToken(): string {
      // const userStore = useUserStore();
      // const wordpressApiKey: string = userStore.userInfo.wordpressApiKey;
      // if (wordpressApiKey !== null && wordpressApiKey) {
      //   const decodedToken = jwtDecode(wordpressApiKey);
      //   if (decodedToken.exp) {
      //     return new Date(decodedToken.exp * 1000).toISOString();
      //   }
      // }
      return '';
    },
    async getApiKey() {
      //   const tokenStore = useTokenStore();
      //   const userStore = useUserStore();
      //   this.dialog = true;
      //   if (this.getNewKey || userStore.userInfo.wordpressApiKey === null) {
      //     this.getNewKey = false;
      //     this.hasKey = true;
      //     this.requestKey = false;
      //     await WordpressController.getApiKey(
      //       us.accessToken,
      //       app.$data.refreshToken
      //     ).then((response) => {
      //       if (response.status === AuthResponseStatus.SUCCESS) {
      //         this.setTokens(response);
      //         app.$data.userInfo.wordpressApiKey = response.bearerKey;
      //       } else {
      //         this.dialog = false;
      //       }
      //       this.setSnackbar(response);
      //     });
      //   }
    }
  },
  async mounted() {
    await PageHelper.checkLogin();
  }
};
